import "./api.js";
import { c as currentCustomer } from "./customer.js";
currentCustomer.subscribe((val) => {
  if (val && typeof val.uuid !== "undefined") {
    val.uuid;
  }
});
//# sourceMappingURL=qualification.js.map
